const DEFAULT_MFA_STATE = {
    primaryInfo: null,
    isEnrolling: false,
    smsOtp: {
        isSending: false,
        sendError: null,
        codeExpiration: null,
        formattedDestination: null,
        enrolledNumber: null
    },
    totp: {
        enrollment: null
    }
};

export { DEFAULT_MFA_STATE };
//# sourceMappingURL=MfaState.mjs.map
